module.exports = __webpack_public_path__ + "static/img/des9-bg2.d3300e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/des9-bg2.png
// module id = /3TL
// module chunks = 0